module.exports = __webpack_public_path__ + "img/4.63a6fde3.jpg";